export { synthesisConstants };

const synthesisConstants = {
  FRANCE_POPULATION: 65 * Math.pow(10, 6),
  MILLIARD: Math.pow(10, 9),
  DAYS_IN_YEAR: 365,
  KG_TO_TON: 0.001,
} as const;
